/**
 * UI labels for 24h risk score freshness SLA (mirrors @stavyn/shared/riskScoreFreshness).
 */
import { riskStateFromEmployee } from './employeeRiskState';

const { computeRiskScoreFreshness } = require('@stavyn/shared/riskScoreFreshness');

export function freshnessFromEmployee(employee) {
  if (employee?.riskState?.freshnessStatus) {
    return {
      freshnessStatus: employee.riskState.freshnessStatus,
      riskScoreStatus: employee.riskState.riskScoreStatus,
      isFresh: employee.riskState.isFresh,
      isStale: employee.riskState.isStale,
      lastUpdatedAt: employee.riskState.lastUpdatedAt,
    };
  }
  const rs = riskStateFromEmployee(employee);
  if (rs?.freshnessStatus) {
    return {
      freshnessStatus: rs.freshnessStatus,
      riskScoreStatus: rs.riskScoreStatus,
      isFresh: rs.isFresh,
      isStale: rs.isStale,
      lastUpdatedAt: rs.lastUpdatedAt,
    };
  }
  return computeRiskScoreFreshness(employee);
}

export function freshnessBadgeLabel(freshnessStatus) {
  const s = String(freshnessStatus || '').toLowerCase();
  if (s === 'fresh') return 'Fresh';
  if (s === 'stale') return 'Stale';
  if (s === 'updating') return 'Updating';
  if (s === 'failed') return 'Failed';
  return null;
}

export function freshnessBadgeTitle(freshnessStatus) {
  const s = String(freshnessStatus || '').toLowerCase();
  if (s === 'fresh') return 'Risk score updated within the last 24 hours';
  if (s === 'stale') return 'Risk score is older than 24 hours; refresh is scheduled';
  if (s === 'updating') return 'Risk score refresh in progress';
  if (s === 'failed') return 'Risk score refresh failed — retry from Imports or Settings';
  return null;
}

/**
 * When true, numeric score must not be presented as the current authoritative value.
 */
export function shouldBlockStaleScoreAsCurrent(freshnessStatus) {
  return String(freshnessStatus || '').toLowerCase() === 'stale';
}
